// extracted by mini-css-extract-plugin
export default {"offpeakDiscounts":"style--offpeakDiscounts--45c34a","offpeakAppointments":"style--offpeakAppointments--af1c9e","heading":"style--heading--b75c64","section":"style--section--09fd6b"};